// Product classifications (stored as keys on the product; labels are bilingual).
export const GENDERS = [
  { key: "masculine", en: "Masculine", ar: "رجالي" },
  { key: "feminine", en: "Feminine", ar: "نسائي" },
  { key: "unisex", en: "Unisex", ar: "للجنسين" },
];

export const COMPLEXITY = [
  { key: "accessible", en: "Accessible", ar: "سهل", desc_en: "Easy to understand and enjoy.", desc_ar: "سهل الفهم والاستمتاع به." },
  { key: "moderate", en: "Moderate", ar: "متوسط", desc_en: "Balanced complexity with noticeable layers.", desc_ar: "تعقيد متوازن بطبقات واضحة." },
  { key: "complex", en: "Complex", ar: "معقّد", desc_en: "Rich, multi-layered composition with evolving accords.", desc_ar: "تركيبة غنية متعددة الطبقات بنوتات تتطور مع الوقت." },
  { key: "experimental", en: "Experimental", ar: "تجريبي", desc_en: "Highly unconventional and intricate olfactory composition.", desc_ar: "تركيبة عطرية غير تقليدية ومعقّدة للغاية." },
];

export const CHARACTER = [
  { key: "mass_appealing", en: "Mass Appealing", ar: "محبوب للجميع", desc_en: "Widely appealing and easy to wear.", desc_ar: "جذّاب لشريحة واسعة وسهل الارتداء." },
  { key: "sophisticated", en: "Sophisticated", ar: "راقٍ", desc_en: "Refined, distinctive, and elegant.", desc_ar: "راقٍ ومميّز وأنيق." },
  { key: "bold", en: "Bold", ar: "جريء", desc_en: "Strong, daring, and unconventional.", desc_ar: "قوي وجريء وغير تقليدي." },
  { key: "experimental", en: "Experimental", ar: "تجريبي", desc_en: "Artistic, challenging, and highly unusual.", desc_ar: "فنّي ومُتحدٍّ وغير مألوف إطلاقاً." },
];

export const CLASS_TITLES = {
  gender: { en: "Fragrance Gender", ar: "جنس العطر" },
  complexity: { en: "Olfactory Complexity", ar: "التعقيد العطري" },
  character: { en: "Scent Character", ar: "شخصية الرائحة" },
};

export const SEASONS = [
  { key: "summer", en: "Summer", ar: "صيفي" },
  { key: "winter", en: "Winter", ar: "شتوي" },
  { key: "spring", en: "Spring", ar: "ربيعي" },
  { key: "autumn", en: "Autumn", ar: "خريفي" },
  { key: "all", en: "All Seasons", ar: "مناسب لجميع الفصول" },
];

export const ENVIRONMENTS = [
  { key: "indoor", en: "Indoor Spaces", ar: "الأماكن المغلقة" },
  { key: "outdoor", en: "Outdoor Spaces", ar: "الأماكن المفتوحة" },
  { key: "both", en: "Both Indoor & Outdoor", ar: "مناسب لكلا البيئتين" },
];

export const WEAR_TITLES = {
  seasons: { en: "Weather Suitability", ar: "الطقس المناسب" },
  environment: { en: "Wearing Environment", ar: "بيئة الاستخدام" },
};

// "All seasons" is exclusive of individual seasons.
export const toggleSeason = (current, key) => {
  const list = current || [];
  if (list.includes(key)) return list.filter((s) => s !== key);
  return key === "all" ? ["all"] : [...list.filter((s) => s !== "all"), key];
};
